// src/lib/firebase.js
// ─────────────────────────────────────────────────────────────────────────────
// Firebase client — single instance shared across the whole app.
// Import { db, auth, storage } from here wherever you need them.
// ─────────────────────────────────────────────────────────────────────────────
import { initializeApp }         from 'firebase/app';
import { getFirestore }          from 'firebase/firestore';
import { getAuth }               from 'firebase/auth';
import { getStorage }            from 'firebase/storage';

// These values come from your .env file — never hardcode them here.
const firebaseConfig = {  
  apiKey: "AIzaSyDE7OL9_lPr3xJ8f0-N4IHcZphEqw81LSw",
  authDomain: "express-holidays-fea2a.firebaseapp.com",
  projectId: "express-holidays-fea2a",
  storageBucket: "express-holidays-fea2a.firebasestorage.app",
  messagingSenderId: "63301926042",
  appId: "1:63301926042:web:34860e3e0b18894569b323"

};

// Validate — catch missing .env early with a clear message
const missing = Object.entries(firebaseConfig)
  .filter(([, v]) => !v)
  .map(([k]) => k);

if (missing.length > 0) {
  console.error(
    '[Firebase] Missing environment variables:\n' +
    missing.map(k => `  ${k}`).join('\n') + '\n' +
    'Copy .env.example to .env and fill in your Firebase project values.\n' +
    'Then restart: npm start'
  );
}

const app = initializeApp(firebaseConfig);

export const db      = getFirestore(app);   // Firestore database
export const auth    = getAuth(app);        // Authentication
export const storage = getStorage(app);     // File storage (images)
